// globals.ts
import { Injectable } from '@angular/core';
import { CommonGlobals } from './common.global';

@Injectable()
export class Globals {
  role = 'test';

  public commonGlobal = CommonGlobals;
}
